import { gpHome } from '../app';
import { AccountsService } from '../services/accounts-service';
import { IAuthService } from '../services/auth-service';

interface IConfirmEmailChangeScope extends ng.IScope {
    confirmationSuccessful: boolean;
    confirmationResending: boolean;
    confirmationResent: boolean;
    confirmationResentError: boolean;
    confirmationError: string;
    confirming: boolean;
    resendEmail(): void;
}

gpHome.controller(
    'confirmemailchangeController',
    [
        '$scope',
        'accountsService',
        'authService',
        '$routeParams',
        function (
            $scope: IConfirmEmailChangeScope,
            accountsService: AccountsService,
            authService: IAuthService,
            $routeParams: ng.route.IRouteParamsService) {

            let userId = $routeParams['userId'];
            let code = $routeParams['code'];

            $scope.confirming = true;

            accountsService.confirmEmailChange(userId, code)
                .then(() => {
                    $scope.confirmationSuccessful = true;
                    authService.logOut();
                })
                .catch(value => $scope.confirmationError = value)
                .finally(() => $scope.confirming = false);
        }]);

